export interface TelegramWebApp {
  initData: string;
  initDataUnsafe: unknown;
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string | number>;
  expand: () => void;
  close: () => void;
  ready: () => void;
}

declare global {
  interface Window {
    Telegram?: {
      WebApp?: TelegramWebApp;
    };
  }
}

export const getTelegramWebApp = (): TelegramWebApp | null => {
  if (typeof window === 'undefined') return null;
  return window.Telegram?.WebApp ?? null;
};

export const initTelegramWebApp = (): TelegramWebApp | null => {
  const webApp = getTelegramWebApp();
  if (!webApp) return null;

  try {
    webApp.ready();
    webApp.expand();
  } catch {
    // ignore
  }

  return webApp;
};

export const getTelegramInitData = (): string | null => {
  const webApp = getTelegramWebApp();
  return webApp?.initData ?? null;
};

